module.exports = __webpack_public_path__ + "img/BPriest64_ua.e32b4728.webp";